import { createSlice } from "@reduxjs/toolkit";

const homeSlice = createSlice({
    name: 'home',
    initialState: {
        currency: [],
        store_locations: [],
        isLogin: false,
        user: null,
        session_id: '',
        currencycode: '',
        currencyicon: '',
        currencyflag: '',
        menu: [],
        showaccount: false,
        clickblogcomment: false,
        clickklevu: false,
        isBlogLike: false,
        isSpecialClicked: false
    },
    reducers: {
        // klevu start
        isSpecialClicked: (state, action) => {
            state.isSpecialClicked = action.payload
        },
        clickklevu: (state, action) => {
            state.clickklevu = action.payload
        },
        // klevu end
        
        clickblogcomment: (state, action) => {          // blog page 
            state.clickblogcomment = action.payload
        },
        showaccount: (state, action) => {
            state.showaccount = action.payload
        },
        sessionId: (state, action) => {
            state.session_id = action.payload
        },
        isLogin: (state, action) => {
            state.isLogin = action.payload
        },
        user: (state, action) => {
            state.user = action.payload
        },
        currency: (state, action) => {
            state.currency = action.payload
            if (state.currencycode == '') {
                state.currencycode = action.payload[0].currency_code
            }
            if (state.currencyicon == '') {
                state.currencyicon = action.payload[0].currency_icon
            }
            if (state.currencyflag == '') {
                state.currencyflag = action.payload[0].country_flag
            }
        },
        currencyicon: (state, action) => {
            state.currencyicon = action.payload
        },
        currencycode: (state, action) => {
            state.currencycode = action.payload
        },
        currencyflag: (state, action) => {
            state.currencyflag = action.payload
        },
        menu: (state, action) => {
            state.menu = action.payload
        },
        store_locations: (state, action) => {
            state.store_locations = action.payload
        },
        isBlogLike:(state,action)=>{
            state.isBlogLike = action.payload
        },
    }
})
export const { sessionId, currency, currencyicon, currencycode, currencyflag, menu, isLogin, user, store_locations, showaccount, clickklevu,isBlogLike, clickblogcomment, isSpecialClicked } = homeSlice.actions
export default homeSlice.reducer